import 'react';
import { useToast, ToastProvider } from 'react-native-toast-notifications';

// new line custom hook

const notifyOnClient = _ref => {
  let {
    title,
    body
  } = _ref;
  if (window.electronAPI && window.electronAPI.showNotification) {
    window.electronAPI.showNotification(title, body);
  }
};

var AppToast = {
  useToast,
  ToastProvider,
  notifyOnClient
};

export { AppToast as default };
